<template>
  <div>
    <details-modal
      :show="show"
      current-operation="create"
      @close="closeModal"
      @cancel="closeModal"
      @create="institutionButtonClicked"
    >
      <form id="addPersonToInstitutionForm">
        <div class="row form-group2">
          <person-select
            v-validate="'required'"
            v-model="personId"
            placeholder="Ajoutez une personne"
            data-vv-scope="formMembershipDetails"
            name="personne"
            required
          />
        </div>
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first(`formAddPersonToInstitutionForm.personne`) }}
        </div>
        <div class="row mt-4 text-left">
          <p-checkbox v-model="isContactPerson" inline>
            <div>
              la personne sélectionnée est la personne de contact de cette
              institution
            </div>
          </p-checkbox>
        </div>
      </form>
      <p v-if="errorMessage" class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
  </div>
</template>

<script>
import PCheckbox from 'src/components/UIComponents/Inputs/Checkbox.vue';
import PersonSelect from 'src/components/ApplicationViews/UIComponents/PersonSelect';
import DetailsModal from './DetailsModal.vue';

export default {
  components: {
    PCheckbox,
    PersonSelect,
    DetailsModal,
  },
  props: {
    show: Boolean,
    institutionId: Number,
  },
  data() {
    return {
      personId: null,
      isContactPerson: false,
      errorMessage: '',
    };
  },
  methods: {
    institutionButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formMembershipDetails').then(result => {
        if (result) {
          this.errorMessage = null;

          this.$http
            .post(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/people/${this.personId}/institutions`,
              {
                institutionId: this.institutionId,
                isContactPerson: this.isContactPerson,
              },
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              if (error.response.status === 409) {
                this.errorMessage =
                  "L'institution est déjà associé à cette personne.";
              } else {
                this.errorMessage =
                  "Une erreur est survenue l'association de l'institution à la personne, veuillez réessayer ou contacter le support.";
              }
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    closeModal() {
      this.$emit('close');
      this.errorMessage = '';
      this.personId = null;
      this.isContactPerson = false;
      document.getElementById('addPersonToInstitutionForm').reset();
    },
  },
};
</script>

<style scoped>
.validation-error {
  color: red;
  margin-bottom: 1em;
}
</style>
